import { fetchWrapper } from '@/helpers'

const ruta = process.env.VUE_APP_ROOT_API

export default class SharedBarcodeScannerService {
  async crear(scannerUrl, sessionId) {
    return await fetchWrapper.post(`${ruta}/scanner-compartido/crear`, {
      scanner_url: scannerUrl,
      session_id: sessionId
    })
  }

  async cerrar(sessionId) {
    return await fetchWrapper.post(`${ruta}/scanner-compartido/${sessionId}/cerrar`)
  }

  websocketUrl(sessionId, role) {
    const configuredUrl = process.env.VUE_APP_SCANNER_WS_URL
    const baseUrl = this.normalizeWebsocketUrl(
      configuredUrl ||
        `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}/scanner-ws`
    )
    const url = new URL(baseUrl, window.location.origin)

    url.searchParams.set('session_id', sessionId)
    url.searchParams.set('role', role)

    return url.toString()
  }

  normalizeWebsocketUrl(url) {
    if (!url) return url

    let normalized = url.trim()
    normalized = normalized.replace(/^wss?:\/\/https:\/\//, 'wss://')
    normalized = normalized.replace(/^wss?:\/\/http:\/\//, 'ws://')
    normalized = normalized.replace(/^https:\/\//, 'wss://')
    normalized = normalized.replace(/^http:\/\//, 'ws://')

    return normalized
  }
}
